<template>
  <div>
    <pageTable/>
  </div>
</template>

<script>
import PageTable from './components/table';
export default {
  name: 'transport-freightScmDeduction',
  components: {
    PageTable,
  },
}
</script>